import {
  HTTPMethods,
  RequestExecutor,
} from "../../api-helpers/RequestExecutor";
import { getCRMEndpoints } from "../../config";
import {
  CreateOrUpdateMacroRequest,
  GetMacrosRequest,
} from "../../ui-components/macro-builder/macroNode.types";

export class CrmService {
  async getCrmContext(customerId: string, storeId: string) {
    const path = `${getCRMEndpoints()}/chatSessionFunctions-getLatestChatSession`;
    const res = (await RequestExecutor.fetch({
      apiPath: path,
      apiMethod: HTTPMethods.POST,
      requestBody: {
        customerId: customerId,
        storeId: storeId,
      },
    })) as any;
    return res?.data?.chatSession?.chatSessionId;
  }

  async getChatStages(storeId: string) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/chatStageApiFunctions-getChatStages`,
        apiMethod: HTTPMethods.POST,
        requestBody: { storeId: storeId },
      });
    } catch (error: any) {
      return;
    }
  }

  async getChatLabels(storeId: string, includeDefaultLabels: boolean = true) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/labelsApiFunctions-getAllLabels`,
        apiMethod: HTTPMethods.POST,
        requestBody: { storeId: storeId, includeDefaultLabels },
      });
    } catch (error: any) {
      return;
    }
  }

  async getCustomerTags(storeId: string) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/customerTagApiFunctions-getCustomerTags`,
        apiMethod: HTTPMethods.POST,
        requestBody: { storeId: storeId },
      });
    } catch (error: any) {
      return;
    }
  }

  async getGroupedLabels(
    storeId: string | null = null,
    fetchArchived: boolean,
    includeDefaultLabels: boolean = true
  ) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/labelsApiFunctions-getAllLabelsGrouped`,
        apiMethod: HTTPMethods.POST,
        requestBody: { storeId, fetchArchived, includeDefaultLabels },
      });
    } catch (error: any) {
      return;
    }
  }

  async getTeams(storeId: string) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/teamApiFunctions-getTeams`,
        apiMethod: HTTPMethods.POST,
        requestBody: { storeId: storeId },
      });
    } catch (error: any) {
      return;
    }
  }

  async getUsers(
    storeId: string,
    fetchAssignmentEligibleUsers = true,
    email?: string
  ) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/userApiFunctions-getUsers`,
        apiMethod: HTTPMethods.POST,
        requestBody: {
          storeId: storeId,
          email: email,
          fetchAssignmentEligibleUsers: fetchAssignmentEligibleUsers,
        },
      });
    } catch (error: any) {
      return;
    }
  }

  async createOrUpdateMacro(payload: CreateOrUpdateMacroRequest) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/macroApiFunctions-createOrUpdateMacro`,
        apiMethod: HTTPMethods.POST,
        requestBody: payload,
      });
    } catch (error: any) {
      return;
    }
  }

  async getMacros({ storeId, macroId }: GetMacrosRequest) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/macroApiFunctions-getMacros`,
        apiMethod: HTTPMethods.POST,
        requestBody: { storeId, macroId },
      });
    } catch (error: any) {
      return;
    }
  }

  async getTicketForms(storeId: string) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/ticketFormApiFunctions-getTicketForms`,
        apiMethod: HTTPMethods.POST,
        requestBody: {
          storeId,
          isActive: true,
          searchTerm: "",
          page: 1,
          limit: 100, // Assuming 100 is enough to fetch all forms acc to current usage. Adjust if pagination is needed.
        },
      });
    } catch (error: any) {
      return;
    }
  }
  async getTicketFormFieldMapping(storeId: string, formId: string) {
    try {
      return await RequestExecutor.fetch({
        apiPath: `${getCRMEndpoints()}/ticketFormApiFunctions-getTicketFormFieldMap`,
        apiMethod: HTTPMethods.POST,
        requestBody: {
          storeId,
          formId,
          activeOnly: true,
        },
      });
    } catch (error: any) {
      return;
    }
  }
}
